import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ProductCenterView from '../views/ProductCenterView.vue'
import ProductDetailView from '../views/ProductDetailView.vue'
import ProductAdminView from '../views/ProductAdminView.vue'
import SolutionsView from '../views/SolutionsView.vue'
import AboutView from '../views/AboutView.vue'
import DownloadsView from '../views/DownloadsView.vue'
import NewsView from '../views/NewsView.vue'
import TrainingView from '../views/TrainingView.vue'
import AcademyHomeView from '../views/AcademyHomeView.vue'
import AcademyCourseView from '../views/AcademyCourseView.vue'
import AcademyMineView from '../views/AcademyMineView.vue'
import AcademyExamView from '../views/AcademyExamView.vue'
import AcademyKnowledgeView from '../views/AcademyKnowledgeView.vue'
import { defaultCategoryId } from '../data/productCatalog'
import { defaultSolutionTab } from '../data/solutionsCatalog'
import { company } from '../data/siteConfig'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: { title: '首页' },
    },
    {
      path: '/about',
      name: 'about',
      component: AboutView,
      meta: { title: '关于我们' },
    },
    {
      path: '/downloads',
      name: 'downloads',
      component: DownloadsView,
      meta: { title: '下载中心' },
    },
    {
      path: '/news/:category?',
      name: 'news',
      component: NewsView,
      meta: { title: '新闻动态' },
    },
    {
      path: '/training',
      name: 'training',
      component: AcademyHomeView,
      meta: { title: '高仁学堂' },
    },
    {
      path: '/training/schedule',
      name: 'training-schedule',
      component: TrainingView,
      meta: { title: '培训安排' },
    },
    {
      path: '/training/course/:courseId',
      name: 'training-course',
      component: AcademyCourseView,
      meta: { title: '课程详情' },
    },
    {
      path: '/training/mine',
      name: 'training-mine',
      component: AcademyMineView,
      meta: { title: '我的学习' },
    },
    {
      path: '/training/exam',
      name: 'training-exam',
      component: AcademyExamView,
      meta: { title: '在线考试' },
    },
    {
      path: '/training/knowledge',
      name: 'training-knowledge',
      component: AcademyKnowledgeView,
      meta: { title: '知识资料' },
    },
    {
      path: '/solutions/:tab?',
      name: 'solutions',
      component: SolutionsView,
      meta: { title: '解决方案' },
      beforeEnter(to) {
        if (!to.params.tab) {
          return { name: 'solutions', params: { tab: defaultSolutionTab } }
        }
      },
    },
    {
      path: '/products/admin',
      name: 'product-admin',
      component: ProductAdminView,
      meta: { title: '上架产品' },
    },
    {
      path: '/products/:categoryId/:productSlug',
      name: 'product-detail',
      component: ProductDetailView,
      meta: { title: '产品详情' },
    },
    {
      path: '/products/:categoryId?',
      name: 'products',
      component: ProductCenterView,
      meta: { title: '产品中心' },
      beforeEnter(to) {
        if (!to.params.categoryId) {
          return { name: 'products', params: { categoryId: defaultCategoryId } }
        }
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }
    if (to.name === 'products' && from.name === 'products') {
      return false
    }
    if (to.name === 'solutions' && from.name === 'solutions') {
      return false
    }
    return { top: 0, behavior: 'smooth' }
  },
})

router.afterEach((to) => {
  const pageTitle = to.meta.title || ''
  document.title = pageTitle
    ? `${pageTitle} - ${company.shortName}`
    : `${company.shortName} - 工业机器人与职业教育技术服务`
})

export default router
